/**
 * Stand-in employment and housing for the alumni console until the API carries them.
 *
 * Neither KIPU's import nor `client_profiles` has these yet, so they are hard-coded here for the
 * invented alumni the local server seeds (`services/graphql/local-client-seed.ts`), matched by
 * email. Keyed that tightly on purpose: a real client on Test must never be shown made-up details,
 * so anyone not listed here gets nothing and the profile says "Not on file".
 *
 * Delete this file when the fields arrive from the API; `toClientRecord` is its only reader.
 */
export interface LifeStatus {
    employment?: string;
    housing?: string;
}

const MOCK_LIFE_STATUS: Readonly<Record<string, LifeStatus>> = {
    "m.ellery@example.com": {
        employment: "Full-time · Boyd Fabrication",
        housing: "Sober living · Hawthorne House",
    },
    "praman@example.com": {
        employment: "Part-time · retail",
        housing: "Living with family",
    },
    "theo.lindqvist@example.com": {
        employment: "Full-time · Capitol Hill Coffee",
        housing: "Renting · shared apartment",
    },
    "rosa.delgado@example.com": {
        employment: "Retired",
        housing: "Owns home",
    },
    "wren.okafor@example.com": {
        employment: "On leave · Mission Bay Dental",
        housing: "In residential treatment",
    },
};

export const mockLifeStatusFor = (email: string): LifeStatus => MOCK_LIFE_STATUS[email] ?? {};
